import appService from 'src/pl.service';

/**
 * @returns {object | undefined} when bound successfuly
 */
 export const getCefSharp = async (objectName) => {
    try {
        console.log('getChefSharp() entered');
        appService.log('getCefSharp() entered');
        // eslint-disable-next-line
        await CefSharp.BindObjectAsync(objectName, 'bound');
        appService.log('CefSharp.BindObjectAsync() called');
        return Promise.resolve(window[objectName]);
    } catch (error) {
        console.log(
        'CefSharpLaunch Error: (most likely not running withn RN->PL app)',
        error
        );
        appService.log(`CefSharp.BindObjectAsync() failed: ${error}`);
        throw error;
    }
};

// Experiemental method that we can use if we find that the getCefSharp() is the cause of bugs
// This is not currently being used.
export const getCefSharp2 = async (objectName) => {
    // Check if already bound
    if (window[objectName]) {
        return Promise.resolve(window[objectName]);
    }

    if (!window.CefSharp) {
        const message = `CefSharp is not available in the current context. Cannot bind '${objectName}'.`
        const error = new Error(message);
        console.error(error.message);
        appService.log(message);
        return Promise.reject(error); // Reject on failure
    }

    try {
        await CefSharp.BindObjectAsync(objectName, 'bound');

        // 4. Verify binding success
        if (window[objectName]) {
            const message = `CefSharp object bound successfully: window.${objectName}`;
            console.log(message);
            appService.log(message);
            return Promise.resolve(window[objectName]);
        } else {
            const message = `Binding successful according to CefSharp, but window.${objectName} is still undefined.`
            appService.log(message);
            throw new Error(message);
        }

    } catch (error) {
        const message = `CefSharp Binding Error for '${objectName}': (Ensure running in CefSharp and object 'bound' is registered): error: ${error}`;
        appService.log(message);
        console.error(
            `CefSharp Binding Error for '${objectName}': (Ensure running in CefSharp and object 'bound' is registered)`,
            error
        );
        // Using throw here because it's inside an async function, which automatically rejects the promise
        throw error;
    }
};